import { apiSlice } from "../api/apiSlice";

export const tasksApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getTasks: builder.query({
      query: () => `/tasks`,
    }),
    addTask: builder.mutation({
      query: (data) => ({
        url: "/tasks",
        method: "POST",
        body: data,
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const res = await queryFulfilled;
          if (res.data) {
            dispatch(
              apiSlice.util.updateQueryData("getTasks", undefined, (draft) => {
                draft.push(res.data);
              })
            );
          }
        } catch (error) {
          console.log(error);
        }
      },
    }),
    removeTask: builder.mutation({
      query: (id) => ({
        url: `/tasks/${id}`,
        method: "DELETE",
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        const pathResult = dispatch(
          apiSlice.util.updateQueryData("getTasks", undefined, (draft) => {
            const taskIndex = draft.findIndex(
              (task) => task.id == JSON.stringify(arg)
            );
            draft.splice(taskIndex, 1);
          })
        );

        try {
          await queryFulfilled;
        } catch (error) {
          pathResult.undo();
        }
      },
    }),
    getTask: builder.query({
      query: (id) => `/tasks/${id}`,
    }),
    updateTask: builder.mutation({
      query: ({ id, data }) => ({
        url: `/tasks/${id}`,
        method: "PATCH",
        body: data,
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        const response = await queryFulfilled;

        if (response?.data?.id) {
          // pessimistic cache update
          dispatch(
            apiSlice.util.updateQueryData("getTasks", undefined, (draft) => {
              let indexToUpdate = draft.findIndex(
                (task) => task.id == arg.id.toString()
              );
              if (indexToUpdate !== -1) {
                draft[indexToUpdate] = response.data;
              }
            })
          );

          dispatch(
            apiSlice.util.updateQueryData(
              "getTask",
              arg.id.toString(),
              (draft) => {
                Object.assign(draft, response.data);
              }
            )
          );
        }
      },
    }),
    changeStatus: builder.mutation({
      query: (data) => ({
        url: `/tasks/${data.id}`,
        method: "PATCH",
        body: {
          status: data.status,
        },
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        const pathResult = dispatch(
          apiSlice.util.updateQueryData("getTasks", undefined, (draft) => {
            const task = draft.find(
              (task) => task.id == JSON.stringify(arg.id)
            );
            task.status = arg.status;
          })
        );

        try {
          await queryFulfilled;
        } catch (error) {
          pathResult.undo();
        }
      },
    }),
  }),
});

export const {
  useGetTasksQuery,
  useGetTaskQuery,
  useChangeStatusMutation,
  useAddTaskMutation,
  useRemoveTaskMutation,
  useUpdateTaskMutation,
} = tasksApi;
